import hasWhitespacesOnly from './common/hasWhitespacesOnly';
import incorrectDataType from './common/incorrectDataType';
import isEmpty from './common/isEmpty';
import isNull from './common/isNull';
import isUndefined from './common/isUndefined';

export const isValidOTP = (otp) => {
  if (
    isNull(otp) ||
    isUndefined(otp) ||
    incorrectDataType(otp, 'string') ||
    hasWhitespacesOnly(otp) ||
    isEmpty(otp)
  ) {
    return false;
  } else {
    return String(otp).length === 6;
  }
};

export const filterOTP = (otp) => {
  return otp.replace(/[^0-9.]/g, '');
};
